import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Flex, Menu, MenuButton, MenuItem, MenuList, mode, Text, useColorMode } from '@abb/uikit';
import { ChevronRight } from '@abb/uikit/icons/outline/arrow';
import { Check } from '@abb/uikit/icons/solid/general';
import { Moon01, Sun } from '@abb/uikit/icons/solid/weather';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Contrast02 from 'shared-components/icons/Contrast-icon';
import { setColorMode } from 'utils/setColorMode';
export const ColorMode = ()=>{
    const { t } = useTranslation('common');
    const { colorMode, toggleColorMode } = useColorMode();
    return /*#__PURE__*/ _jsxs(Menu, {
        placement: "left-start",
        children: [
            /*#__PURE__*/ _jsx(MenuButton, {
                mt: "2px",
                w: "100%",
                "data-test-id": "color-mode",
                children: /*#__PURE__*/ _jsxs(Flex, {
                    w: "100%",
                    alignItems: "center",
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ _jsxs(Flex, {
                            alignItems: "center",
                            gap: 3,
                            children: [
                                /*#__PURE__*/ _jsx(Contrast02, {}),
                                /*#__PURE__*/ _jsxs(Box, {
                                    textAlign: "start",
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            children: t('user_settings.color_mode')
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            fontSize: "14px",
                                            color: "#7A7D82",
                                            children: t(`user_settings.${colorMode}`)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(ChevronRight, {
                            stroke: "#7A7D82"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(MenuList, {
                p: 1,
                borderRadius: "24px",
                mr: "10px",
                children: [
                    /*#__PURE__*/ _jsx(MenuItem, {
                        p: "12px",
                        onClick: ()=>colorMode === 'dark' && setColorMode('light', toggleColorMode),
                        borderRadius: "12px",
                        _hover: {
                            bg: mode('#FAFAFA', '#292B2E')({
                                colorMode
                            })
                        },
                        "data-test-id": "color-mode-light",
                        icon: /*#__PURE__*/ _jsx(Sun, {
                            fill: "#F0F0F0",
                            stroke: mode('black', '#F0F0F0')({
                                colorMode
                            })
                        }),
                        children: /*#__PURE__*/ _jsxs(Flex, {
                            justifyContent: "space-between",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ _jsx(Text, {
                                    children: t('user_settings.light')
                                }),
                                colorMode === 'light' && /*#__PURE__*/ _jsx(Check, {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(MenuItem, {
                        p: "12px",
                        _hover: {
                            bg: mode('#FAFAFA', '#292B2E')({
                                colorMode
                            })
                        },
                        "data-test-id": "color-mode-dark",
                        onClick: ()=>colorMode === 'light' && setColorMode('dark', toggleColorMode),
                        borderRadius: "12px",
                        icon: /*#__PURE__*/ _jsx(Moon01, {
                            fill: "#F0F0F0",
                            stroke: mode('black', '#F0F0F0')({
                                colorMode
                            })
                        }),
                        children: /*#__PURE__*/ _jsxs(Flex, {
                            justifyContent: "space-between",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ _jsx(Text, {
                                    children: t('user_settings.dark')
                                }),
                                colorMode === 'dark' && /*#__PURE__*/ _jsx(Check, {})
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
